module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('div', {
    staticClass: "logo"
  }), _c('v-container', [_c('v-text-field', {
    attrs: {
      "label": "Game code",
      "type": "number"
    },
    model: {
      value: (_vm.gameCode),
      callback: function($$v) {
        _vm.gameCode = $$v
      },
      expression: "gameCode"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "Name"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _c('v-layout', {
    attrs: {
      "justify-space-around": "",
      "mt-3": ""
    }
  }, [(!_vm.connection) ? [_c('v-btn', {
    on: {
      "click": function($event) {
        _vm.create()
      }
    }
  }, [_vm._v("Create")]), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.join()
      }
    }
  }, [_vm._v("Join")])] : (_vm.connection == 'CONNECTING') ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": ""
    }
  }) : _c('span', {
    staticClass: "raw"
  }, [_vm._v(_vm._s(_vm.connection))])], 2), _c('v-layout', {
    attrs: {
      "mt-3": ""
    }
  }, [_c('span', {
    staticClass: "body-1"
  }, [_vm._v("Go to "), _c('a', {
    attrs: {
      "href": "/secret-hitler/spectate/"
    }
  }, [_vm._v("/secret-hitler/spectate/")]), _vm._v(" to get a better view of the game")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ffb130e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.player/ui/routes/HomeView/login-page.vue
// module id = 358
// module chunks = 0